/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import agGridHelpers from "../../shared/ag-grid-helper";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { EditIconRenderer, GridEditHeader, ReadOnlyCheckBoxRenderer } from "../../shared/ag-grid-helper/GridRenderers";
import Field from "../../shared/forms/Field";
import FormMultiSelect from "../../shared/forms/FormFields/FormMultiSelect";
import FormTextBox from "../../shared/forms/FormFields/FormTextBox";
import FormInputNumber from "../../shared/forms/FormFields/FormInputNumber";
import Buttons from "../../shared/forms/FormFilter/Buttons";
import Filters from "../../shared/forms/FormFilter/Filters";
import FormFilter from "../../shared/forms/FormFilter/FormFilter";
import useForm from "../../shared/forms/useForm";
import useApiBonosRh from "../../api/catalogos/useApiBonosRh"
import SidebarEditForm from "../../shared/forms/SideBarEditForm";
import Form from "../../shared/forms/Form";
import FormCheckBox from "../../shared/forms/FormFields/FormCheckBox";

const filtroInicial = {
    nombre: '', estatus: 1
};

const BonosRh = () => {
    const { values: filter, onChange: onFilterChange, onClear } = useForm(filtroInicial);
    const estatus = [{ id: 1, nombre: "Activa" }, { id: 2, nombre: "Inactiva" }];
    const [datos, setDatos] = useState([]);
    const [currentId, setCurrentId] = useState({});
    const api = useApiBonosRh();

    const filtrar = async (filtro) => {

        const result = await api.filtrar(filtro);
        setDatos(result);
    };

    const gridConfig = {
        rowSelection: 'single',
        enableSorting: true,
        frameworkComponents: {
            readOnlyCheckBoxRenderer: ReadOnlyCheckBoxRenderer,
            editRenderer: EditIconRenderer,
            editHeader: GridEditHeader
        },
        defaultColDef: agGridHelpers.defaultColumns        
    };

    const sideBarCommon = {
        onSaved: () => {
            filtrar(filter).then();
            setCurrentId({});
        },
        onCancel: () => setCurrentId({})
    };

    return (
        <>
            <h5>Bonos Recursos Humanos</h5>
            <FormFilter columns={4} filter={filter} onChange={onFilterChange} onClear={onClear} onFilter={(filtro) => filtrar(filtro, null)}>
                <Filters>
                    <Field label={'Nombre'} field={'nombre'} render={FormTextBox} />
                    <Field label={'Estatus'} field={'estatus'} options={estatus} render={FormMultiSelect} />
                </Filters>
                <Buttons filter={true} clear={true}></Buttons>
            </FormFilter>
            <div className="ag-theme-balham grid-principal">
                <AgGridReact {...gridConfig}
                    onGridReady={() => filtrar(filter).then()}
                    rowHeight={40}
                    rowData={datos}
                    context={{ onEdit: (id) => setCurrentId({ bonos: id }), onAdd: () => setCurrentId({ bonos: 0 }) }}>
                    <AgGridColumn field="nombre" headerName="Nombre" cellClass={'left'} />
                    <AgGridColumn field="activo" headerName="Activo" cellClass={'center'} cellRenderer={'readOnlyCheckBoxRenderer'} />
                    <AgGridColumn field="cantidad" headerName="Cantidad" cellClass={'left'} />
                    <AgGridColumn maxWidth={60} headerComponent={'editHeader'} cellClass={'center'} cellRenderer="editRenderer" />
                   
                </AgGridReact>
            </div>
            <SidebarEditForm id={currentId.bonos}
                initialValues={{ activo: true }}
                getByIdFunction={api.obtener}
                saveFunction={api.guardar}
                {...sideBarCommon}>
                <Form>
                    <h5>Bonos Recursos Humanos</h5>
                    <Field field={"nombre"} label={"Nombre"} required={true} render={({onChange, parent, ...props }) =>
                        <FormTextBox {...props} 
                        onChange={(nombre) =>
                            onChange(
                                nombre
                            )}
                        maxLength={200} 
                        />} />
                        
                        <Field field={"cantidad"} label={"Cantidad"} required={true} render={({onChange, parent, ...props }) =>
                          <FormInputNumber  {...props}                 
                          fractionDigits={2}       
                          onChange={(cantidad) =>
                            onChange(
                                cantidad
                            )}/>
                        } />
                       

                        
                    <Field field={"activo"} label={"Activo"} render={FormCheckBox} />
                </Form>
            </SidebarEditForm>
        </>
    )
};

export default BonosRh;